<template>
  <div>
    <p class="black-title">
      通知
    </p>
    <div class="grade">
      <van-tabs v-model="active" type="line" sticky animated>
        <van-tab title="通知">
          <div class="adv">
            <NOdata title="暂无通知~" v-if="this.advLists.length == 0"></NOdata>
            <div v-else class="adv_main">
              <div
                class="adv_item"
                v-for="(item, index) in advLists"
                :key="index"
                @click="open(item)"
              >
                <div class="adv_item_header">
                  <span :class="{ header_img: true, imgWd: item.isck == '0' }"></span>
                  <h3 class="header_text">{{ item.gglbname ? item.gglbname : "-" }}</h3>
                </div>
                <div class="adv_item_content">
                  <div class="content_title">
                    <span v-if="item.sfzd === '1'" class="content_zhiding">置顶</span>
                    <h3 class="content_text">{{ item.ggbt ? item.ggbt : "-" }}</h3>
                  </div>
                  <div class="adv_item_info">
                    <p>{{ item.cjr ? item.cjr : "-" }} {{ item.istzgg == '1' ? '发布' : ''}}</p>
                    <p>{{ item.ggfbsj ? item.ggfbsj : "-" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="消息">
          <div class="message">
            <p class="black-title">
              消息
            </p>
            <template v-if="schoolCode != '12763'">
              <router-link
                class="msg-item"
                tag="div"
                :to="{ path: '/notice', query: { type: 1 } }"
              >
              <span class="imgspan" ><img src="../../../../static/img/unread.png" /></span>
                <div class="dot" v-if="wdtznb > 0">
                  <span class="red-dot">{{ wdtznb }}</span>
                </div>

                <div class="item-text item-text-dot" v-if="wdtznb > 0">
                  <span>未读消息</span>
                  <p>{{ this.unreadList == "undefined" ? "暂无" : this.unreadList }}</p>
                </div>
                <div class="item-text" v-else>
                  <span>未读消息</span>
                  <div class="dot">
                  </div>
                  <p>暂无</p>
                </div>
              </router-link>
              <router-link
                class="msg-item"
                tag="div"
                :to="{ path: '/notice', query: { type: 2 } }"
              >
                <img src="../../../../static/img/read.png"/>
                <div class="item-text">
                  <span>已读消息</span>
                  <p>{{ this.readList == "undefined" ? "暂无" : this.readList }}</p>
                </div>
              </router-link>
            </template>
            <router-link v-else class="msg-item" tag="div" :to="{ path: '/notice' }">
              <img src="../../../../static/img/unread.png"/>
              <div class="dot" v-if="shxx > 0">
                <span class="red-dot">{{ shxx }}</span>
              </div>
              <div class="item-text item-text-dot" v-if="shxx > 0">
                <span>审核消息</span>
              </div>
              <div class="item-text" v-else>
                <span>审核消息</span>
              </div>
            </router-link>
            <router-link class="msg-item" tag="div" :to="{ path: '/adv' }">
              <img src="../../../../static/img/unread.png"/>
              <div class="dot" v-if="wdggnb > 0">
                <span class="red-dot">{{ wdggnb }}</span>
              </div>
              <div class="item-text item-text-dot" v-if="wdggnb > 0">
                <span>已收公告</span>
              </div>
              <div class="item-text" v-else>
                <span>已收公告</span>
              </div>
            </router-link>
            <router-link
              v-if="schoolCode == '10294'"
              class="msg-item"
              tag="div"
              :to="{ path: '/pass/unDeal' }"
            >
              <img src="../../../../static/img/dclxx.png"/>
              <div class="dot" v-if="num > 0">
                <span class="red-dot">{{ num }}</span>
              </div>
              <div class="item-text item-text-dot" v-if="num > 0">
                <span>待处理信息提醒</span>
              </div>
              <div class="item-text" v-else>
                <span>待处理信息提醒</span>
              </div>
            </router-link>
            <router-link
              v-if="schoolCode == '10555' && userType != '2'"
              class="msg-item"
              tag="div"
              :to="{ path: '/notice', query: { type: 3 } }"
            >
              <img src="../../../../static/img/dshmsg.png"/>
              <div class="item-text">
                <span>待审信息</span>
                <p>{{ this.dshList == "undefined" ? "暂无" : this.dshList }}</p>
              </div>
            </router-link>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
  </div>
</template>

<script>
import {Api} from "../../../utils/axios";

export default {
  data() {
    return {
      active: this.$route.query.active ? parseInt(this.$route.query.active) : 0,
      num: 0,
      pendList: "",
      unreadList: "",
      readList: "",
      dshList: "",
      userType: "",
      schoolCode: "",
      xjyj: "",
      wdtznb: 0,
      wdggnb: 0,
      shxx: 0,
      show: false,
      valueList: {
        label: "",
        value: "",
        item: ""
      },
      value: "",
      advLists: ""

      // advList:''
    };
  },
  methods: {
    async getMsg() {
      const res = await Api.getMsgApi();
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].pendingMsg == undefined) {
          res.data[i].pendingMsg = "";
        }
        if (res.data[i].unReadMsg == undefined) {
          res.data[i].unReadMsg = "";
        }
        if (res.data[i].readMsg == undefined) {
          res.data[i].readMsg = "";
        }
        if (res.data[i].dshMsg == undefined) {
          res.data[i].dshMsg = "";
        }
        if (res.data[i].xjyj == undefined) {
          res.data[i].xjyj = "";
        }
        // if(res.data[i].advList == undefined){
        //   res.data[i].advList = ''
        // }
        this.pendList += res.data[i].pendingMsg + "";
        this.unreadList += res.data[i].unReadMsg + "";
        this.readList += res.data[i].readMsg + "";
        this.dshList += res.data[i].dshMsg + "";
        // this.advList += res.data[i].advList + ''
      }
      this.wdtznb = this.unreadList;
      this.wdggnb = res.gglyNbData;
      if (this.pendList == "") {
        this.pendList = "暂无";
      }
      if (this.unreadList == "") {
        this.unreadList = "暂无";
      }
      if (this.readList == "") {
        this.readList = "暂无";
      }
      if (this.dshList == "") {
        this.dshList = "暂无";
      }
      if (this.xjyj == "") {
        this.xjyj = 0;
      }
      // if(this.advList == ''){
      //   this.advList = '暂无'
      // }
      if (res.code == "1") {
        this.wdxx = res.data[0].unReadNum;
        this.shxx = res.data[0].msgNumAll;
        if (res.gglyNbData) {
          this.wdxx = this.wdxx * 1 + res.gglyNbData * 1;
        }
      }
    },
    // 判断用户类型更改设置
    userConfig() {
      let list = JSON.parse(sessionStorage.getItem("userInfo"));
      this.userType = list.userType;
    },
    // 获取待处理list
    async getUnDeal() {
      const res = await Api.getNotShenHeMsg();
      if (res.data) {
        this.num = res.data.length;
      } else {
        this.num = 0;
      }
    },

    async getList() {
      const params = {
        'istzgg':'1'
      }
      const res = await Api.getAdvList(params);
      let concatList = [];
      res.data.forEach((item, index) => {
        concatList[index] = {
          cjr: item.cjr,
          yyzt: item.yyzt,
          ggfbsj: item.ggfbsj,
          ggbt: item.ggbt,
          ggid: item.ggid,
          gglbname: item.gglbname,
          isck: item.isck,
          istzgg: item.istzgg
        };
      });
      this.advLists = concatList;
      this.isfban = res.isfban;
    },
    open(item) {
      if (item.istzgg == "1") {
        this.$router.push({
          name: "advItem",
          params: {
            ggid: item.ggid,
            gglbname: item.gglbname,
            isck: item.isck,
            istzgg: "1"
          }
        });
      }
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    this.getMsg();
    this.userConfig();
    this.getList();
    // this.active = 1;
    // if (this.$route.query.active) {
    //   this.active = parseInt(this.$route.query.active)
    // }else {
    //   this.active = 0
    // }
    if (this.schoolCode == "10294") {
      this.getUnDeal();
    }
  }
};
</script>

<style lang="less">
.van-tabs--line .van-tabs__wrap {
  border-bottom: 1px solid #f4f4f4;
  .van-tab--active {
    .van-tab__text--ellipsis {
      color: #212f6e !important;
    }
  }
  .van-tab__text--ellipsis {
    width: 56px;
    height: 20px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #8f95b5;
    letter-spacing: 0;
    text-align: center;
  }
  .van-tabs__line {
    background-color: #7469f8 !important;
    width: 25px;
    height: 3px;
    border-radius: 1.5px;
  }
}

.message {
  padding: 0 20px;

  .black-title {
    margin: -22px 20px 10px 0;
  }
}

.msg-item {
  background-color: @attendance-background-color-10;
  border-radius: 5px;
  height: 82px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  color: @attendance-color-1;
  margin-bottom: 20px;
}

.msg-item img {
  width: 40px;
  height: 40px;
  margin-right: 16px;
}

.item-text {
  display: grid;
}

.item-text span {
  color: @attendance-color-1;
  font-weight: 600;
}

.item-text p {
  font-size: 14px;
  color: @attendance-color-2;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 8px;
  height: 20px;
}

.item-text label {
  font-size: 14px;
  color: red;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-top: 8px;
  height: 20px;
  margin-left: 20px;
}

.item-text-dot {
  margin-left: 30px;
}
</style>

<style scoped lang="less">
.dot {
  position: relative;
  margin-top: -16px;
  margin-left: -30px;
  z-index: 2;

  .red-dot {
    position: absolute;
    background-color: red;
    color: #ffffff;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    left: 100%;
    bottom: 50%;
  }
}

.imgspan {
  position: relative;
  z-index: 1;
}
</style>
<style lang="less" scoped>
.adv {
  height: 100%;
  background-color: #f2f2f4;
  box-sizing: border-box;
  overflow: auto;
  .adv_main {
    padding: 12px 15px;

    .adv_item {
      background: #ffffff;
      box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      margin-bottom: 12px;
      .adv_item_header {
        display: flex;
        align-items: center;
        height: 40px;
        padding: 0 15px;
        border-bottom: 1px solid #e5e5e5;
        .header_img {
          width: 24px;
          height: 24px;
          background-image: url("~@/assets/images/imgYd.png");
          background-size: 100% 100%;
          background-position: center;
          background-repeat: no-repeat;
          &.imgWd {
            background-image: url("~@/assets/images/imgWd.png");
          }
        }
        .header_text {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #666666;
          font-weight: 400;
          margin-left: 8px;
        }
      }
      .adv_item_content {
        padding: 12px 15px;
        .content_title {
          display: flex;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: bolder;
          line-height: 22px;
          margin-bottom: 14px;
          .content_zhiding {
            width: 32px;
            height: 20px;
            border: 1px solid #7469f8;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #7469f8;
            letter-spacing: 0;
            text-align: center;
            font-weight: 400;
            line-height: 17px;
            margin-right: 10px;
          }
        }
      }
      .adv_item_info {
        display: flex;
        justify-content: space-between;
        p {
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
          font-weight: 400;
        }
      }
    }
  }

  .adv_main_button {
    position: fixed;
    left: 50%;
    bottom: 60px;
    transform: translate(-50%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    width: 215px;
    height: 44px;
    background-color: #7469f8;
    box-shadow: 0px 4px 8px 0px rgba(116, 105, 248, 0.2);
    border-radius: 25px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    line-height: 16px;
    color: #ffffff;
    font-weight: bolder;
    .van-icon {
      margin-right: 8px;
      font-size: 14px;
      border: 1.5px solid #fff;
      border-radius: 2px;
    }
  }
  .back_top {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 8px;
    bottom: 20%;
    width: 40px;
    height: 40px;
    background: #7469f8;
    background-color: #7469f8;
    border-radius: 50%;
    .van-icon {
      color: #fff;
      font-weight: bolder;
      font-size: 25px;
    }
  }
  .successPopup {
    box-sizing: border-box;
    width: 256px;
    height: 318px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 66px;
    .successPopup_icon {
      font-size: 20px;
      position: absolute;
      top: 15px;
      right: 15px;
      color: #999999;
    }
    .successPopup_img {
      width: 137.08px;
      height: 110px;
      margin-bottom: 20px;
    }
    .successPopup_msg {
      font-family: PingFangSC-Semibold;
      font-size: 20px;
      color: #7469f8;
      letter-spacing: 0;
      text-align: center;
      font-weight: 600;
    }
    .successPopup_button {
      width: 100%;
      position: absolute;
      bottom: 0;
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #7469f8;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
      border-top: 1px solid #e5e5e5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/Home/newMsg_10488.vue